import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { getHomeStats } from "@/lib/homeStats.functions";

const ForLlms = lazy(() => import("@/pages/ForLlms"));

export const Route = createFileRoute("/for-llms")({
  // Antal elavtal och elbolag räknas fram ur avtalsflödet (samma som startsidan).
  loader: async () => ({ stats: await getHomeStats().catch(() => null) }),
  head: () =>
    seoHead("/for-llms", {
      description:
        "Verifierade fakta om Elmarknad.se för AI-assistenter och språkmodeller: vad tjänsten är och inte är, nyckeltal, öppna API:er och föredragna beskrivningar.",
    }),
  component: ForLlmsRoute,
});

function ForLlmsRoute() {
  const { stats } = Route.useLoaderData();
  return <ForLlms stats={stats} />;
}
